import Vue from 'vue'
import moment from 'moment'
export default {
  state: {
    positionAnalysisList: [],
    positionAnalysisPopupOpened: false,
    positionAnalysisResult: {},
  },
  getters: {
    hasPositionAnalysisResults: (state) =>
      Object.keys(state.positionAnalysisResult).length > 0,
    positionAnalysisList: (state) => state.positionAnalysisList,
    positionAnalysisPopupOpened: (state) => state.positionAnalysisPopupOpened,
    positionAnalysisResult: (state) => state.positionAnalysisResult,
    positionAnalysisCanCompare: (state) =>
      state.positionAnalysisPopupOpened &&
      state.positionAnalysisList.length >= 1,
  },
  mutations: {
    positionAnalysisReset(state) {
      state.positionAnalysisList = []
      state.positionAnalysisResult = {}
      state.positionAnalysisPopupOpened = false
    },
    positionAnalysisSelectPositions(state, positionsToAddArr = []) {
      if (positionsToAddArr.length < 1) {
        console.warn('positionAnalysisSelectPositions::no-positions-provided')
        return
      }

      let newPositionsArr = [...state.positionAnalysisList]

      //Case: add position one or two
      if (state.positionAnalysisList.length <= 1) {
        newPositionsArr.push(positionsToAddArr[0])
      }
      //Case: Update position two
      if (state.positionAnalysisList.length >= 2) {
        newPositionsArr[1] = positionsToAddArr[0]
      }

      //Sort
      newPositionsArr = newPositionsArr.sort((a, b) =>
        a.timestamp < b.timestamp ? -1 : 1
      )

      state.positionAnalysisList = newPositionsArr.filter((p) => p != null)

      state.positionAnalysisResult = {}
    },
    positionAnalysisPopupOpened: (state, opened) =>
      (state.positionAnalysisPopupOpened = opened),
    positionAnalysisResult: (state, result) =>
      (state.positionAnalysisResult = result),
  },
  actions: {
    positionAnalysisSelectPositions({ commit }, positionsToAddArr = []) {
      commit('positionAnalysisSelectPositions', positionsToAddArr)
    },
    async analyzeSegment({ commit, state }, { positions, vehicleId }) {
      commit('positionAnalysisSelectPositions', positions)

      let sortedPositions = [].concat(state.positionAnalysisList)

      console.log('analyzeSegment', { sortedPositions })

      if (sortedPositions.length < 2) {
        console.warn('Requires two position to compare')
      }

      let dateFrom = moment(sortedPositions[0].datetime).format(
        'YYYY-MM-DD HH:mm:ss'
      )
      let dateTo = moment(sortedPositions[1].datetime).format(
        'YYYY-MM-DD HH:mm:ss'
      )

      let r = ((
        await Vue.$api.v2.get(
          `/v2/historique/analyse_segment?dateheure_debut=${dateFrom}&dateheure_fin=${dateTo}&vehicule_id=${vehicleId}`
        )
      ).data || [{}])[0]

      commit('positionAnalysisResult', r)
      commit('positionAnalysisPopupOpened', true)
    },
    togglePositionAnalysisPopup({ commit }, opened = true) {
      commit('positionAnalysisPopupOpened', opened)
      if (opened === false) {
        commit('positionAnalysisReset')
      }
    },
  },
}
